
export class AppStorage {
    auth: any;
    user: any;
    extratenants: any = null;
}

export class InstallerConfig {
    appinit: boolean = false;
}

